const USED_VOUCHERS_PAGESIZE = 10;
// voucherCosts are disabled for now, not implemented to Moovy backend
const SHOW_VOUCHER_COSTS = false;

export { USED_VOUCHERS_PAGESIZE, SHOW_VOUCHER_COSTS };
